var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isEnabled
      ? _c("div", [
          _c(
            "div",
            { staticClass: "content", style: { height: _vm.height + "px" } },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          !_vm.isReadingMore
            ? _c(
                "a",
                { attrs: { href: "javascript:" }, on: { click: _vm.readMore } },
                [_vm._v("Read More")]
              )
            : _c(
                "a",
                { attrs: { href: "javascript:" }, on: { click: _vm.readLess } },
                [_vm._v("Read Less")]
              ),
        ])
      : _c("div", { staticClass: "content" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }